import { Badge, HStack, Icon, Text } from '@chakra-ui/react';
import capitalize from 'lodash-es/capitalize.js';
import startCase from 'lodash-es/startCase.js';
import {
  ADMIN_NOTE_CATEGORIES,
  ADMIN_NOTE_OPTIONS,
  ADMIN_NOTE_OUTCOMES,
  getNoteOptionIcon,
} from '../utils';
import { Pin } from 'lucide-react';

interface NoteMetadataProps {
  noteType: string;
  category?: string | null;
  outcome?: string | null;
  pinnedAt?: Date | null;
}

export function NoteMetadata({ noteType, category, outcome, pinnedAt }: NoteMetadataProps) {
  const NoteTypeIcon = getNoteOptionIcon(noteType);
  const NoteOutcomeIcon = outcome ? getNoteOptionIcon(outcome) : null;

  return (
    <HStack fontSize="sm" fontWeight="medium" wrap="wrap">
      {pinnedAt ? (
        <Badge
          backgroundColor="bg.accent.inverse-muted"
          borderRadius="full"
          color="fg.inverse"
          gap={1.5}
          p={2}
          textTransform="none"
        >
          <Icon as={Pin} />
        </Badge>
      ) : null}
      <HStack>
        {noteType && NoteTypeIcon ? <NoteTypeIcon size="16px" /> : null}
        {noteType ? (
          <Text whiteSpace="nowrap">
            {ADMIN_NOTE_OPTIONS[noteType as keyof typeof ADMIN_NOTE_OPTIONS]?.label ??
              capitalize(startCase(noteType))}
          </Text>
        ) : null}
      </HStack>
      <HStack>
        {category || outcome ? <Text>･</Text> : null}
        {category ? (
          <Text whiteSpace="nowrap">
            {ADMIN_NOTE_CATEGORIES[category as keyof typeof ADMIN_NOTE_CATEGORIES]?.label ??
              capitalize(startCase(category))}
          </Text>
        ) : null}
      </HStack>
      <HStack>
        {outcome && NoteOutcomeIcon ? <NoteOutcomeIcon size="16px" /> : null}
        {outcome ? (
          <Text whiteSpace="nowrap">
            {ADMIN_NOTE_OUTCOMES[outcome as keyof typeof ADMIN_NOTE_OUTCOMES]?.label ??
              capitalize(startCase(outcome))}
          </Text>
        ) : null}
      </HStack>
    </HStack>
  );
}
